module.exports = __webpack_public_path__ + "static/media/clock.b6b35dde.svg";